export default __webpack_public_path__ + "static/media/gratefl-solar-logo.e9f7d093.png";